export default __webpack_public_path__ + "static/media/plus.dddc2091.svg";